<template>
    <div>
        <div style="padding-bottom: 3%;" class="adway_subheaders">Step 1 / 4: Let’s start with basic info</div>
        <div class="input-area">
          <div class="input-field-area">
              <div class="adway_input_filed_headers">What is your first name?</div>
              <input class="input-filed" type="text" placeholder="eg. Jane" v-model="firstname">
          </div>
          <div class="input-field-area">
              <div class="adway_input_filed_headers">What is your last name?</div>
              <input class="input-filed" type="text" placeholder="eg. Doe" v-model="surname">
          </div>
          <div class="input-field-area">
              <div class="adway_input_filed_headers">What is your email?</div>
              <input class="input-filed" type="text" placeholder="eg. myemail@myemail.com" v-model="email">
          </div>
          <div class="input-field-area">
              <div class="adway_input_filed_headers">What is your phone number?</div>
              <input class="input-filed" type="text" placeholder="123-456-7890" v-model="telephoneNumber" maxlength="50">
          </div>
          <div class="password-area">
            <div class="input-field-area password-inline">
                <div class="adway_input_filed_headers">Create a password</div>
                <input class="input-filed" type="password" placeholder="eg. password" v-model="password">
            </div>
            <div class="input-field-area password-inline" style="margin-right: 0px;">
                <div class="adway_input_filed_headers">Repeat a password</div>
                <input class="input-filed" type="password" placeholder="eg. password" v-model="repeatPassword">
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import toast from '@utils/toast'
export default {
  name: 'PersonalInfo',
  data: function () {
    return {
      firstname: this.driver.name,
      surname: this.driver.surname,
      email: this.driver.email,
      telephoneNumber: this.driver.phoneNumber,
      password: this.driver.password,
      repeatPassword: this.driver.password
    }
  },
  props: {
    driver: Object
  },
  methods: {
    emailCheck () {
      return this.email === ''
    },
    passwordCheck () {
      return this.password === ''
    },
    passwordEquality () {
      return this.password === this.repeatPassword
    },
    repeatPasswordCheck () {
      return this.repeatPassword === ''
    },
    emailValidation () {
      if (!this.email.includes('@') || !this.email.includes('.') || this.email.includes('@.')) {
        return false
      } else {
        return true
      }
    },
    validateInputFileds () {
      if (this.emailCheck() || this.passwordCheck() || this.repeatPasswordCheck() || !this.emailValidation()) {
        return false
      }
      if (this.passwordEquality()) {
        return true
      }
      return false
    },
    changeSomeDriverSettings () {
      if (this.validateInputFileds()) {
        this.driver.name = this.firstname
        this.driver.surname = this.surname
        this.driver.email = this.email
        this.driver.phoneNumber = this.telephoneNumber
        this.driver.password = this.password
        this.$emit('changeDriver', this.driver)
      } else {
        var generalMessage = ''
        if (this.emailCheck()) {
          generalMessage += `Email filed is empty\n`
        }
        if(this.passwordCheck()) {
          generalMessage += `Password filed is empty\n`
        }
        if(this.repeatPasswordCheck()) {
          generalMessage += `Repeat Password filed is empty\n`
        }
        if(!this.emailValidation()) {
          generalMessage += `Email is not valid\n`
        }
        if(!this.passwordEquality()) {
          generalMessage += `Password are not equal\n`
        }
        toast.errorMessage(generalMessage)
      }
    }
  }
}
</script>
